import { memo, useState, useCallback } from 'react';
import { Container, Row, Col, FormControl } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { BzHeading, BzButton } from '../../../components';
import AddWatchListModal from './AddWatchListModal';
import CreateWatchlistModal from "./CreateWatchlistModal";
import CreateCustomWatchListModal from './CreateCustomWatchListModal';
import emptywatchlist from '../../../assets/images/empty-watchlist.svg';
import { getWachlist } from '../../../redux/actions/mutualFund';
import { handleModal } from "../../../redux/actions/modals";
import { getMutualFundProfileList } from '../../../redux/actions/mutualFund';


const newWatchlistsTemplate =
    [
        {
            name: "TrendingNow -Invest in the latest...",
            ranking: "Top 10"
        },
        {
            name: "Nfo",
            ranking: "Top 3"
        },
        {
            name: "Themes",
            ranking: "Top 10"
        }
    ];


const EmptyWatchlistModal = ({ themes, nfo, mutualFund, fundList, setFundList, currentWatchListName, setCurrentWatchListName, arrWatchlist, setArrWatchlist, mutualFundsScrips, setMutualFundsScrips }) => {
    const dispatch = useDispatch();
    const [newWatchlistName, setNewWatchlistName] = useState('');
    const onSelect = (watchlist) => {
        const index = newWatchlistsTemplate.indexOf(watchlist);
        const temp = index === 0 ? mutualFund : index === 1 ? nfo : index === 2 ? themes : "";
        setArrWatchlist(temp);
        dispatch(handleModal([{ "ADD_WATCHLIST": true }, { 'CREATE_WATCHLIST': false }]));
        setCurrentWatchListName(watchlist?.name);
    };

    const onSelectFund = (isChecked, fund) => {
        if (isChecked) {
            setFundList([...fundList, fund]);
        }
        else {
            const temp = fundList.filter(each => each?.id !== fund?.id);
            setFundList(temp);
        }
    };

    const handleCustomWatchList = useCallback((name) => {
        dispatch(handleModal([{ "CREATE_CUSTOM_WATCHLIST": true }, { 'CREATE_WATCHLIST': false }]));
        setCurrentWatchListName(name);
        dispatch(getMutualFundProfileList());
    }, [dispatch]);

    const handleOnCreateWatchlist = () => {
        dispatch(handleModal([{ 'CREATE_WATCHLIST': true }]));
    };

    const onAddWatchlist = (selectedWatchList) => {
        dispatch(getWachlist({ data: fundList, name: currentWatchListName }));
    };

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col md={2} className='d-flex align-items-center pe-4'>
                        <div className='searchbar-wrap'>
                            <div className='searchbox'>
                                <div className='searchicon-wrap'>
                                    <div className='icon-14 icon-search icon-grey'></div>
                                </div>
                                <FormControl size='sm' id='watchlist_search' type='search' className='font-regular scripname-searchtext' placeholder='Search Watchlist' />
                            </div>
                        </div>
                    </Col>
                    <Col md={10} className='d-flex align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>0 funds shortlisted . . . </div>
                    </Col>
                </Row>

                <Row className='g-0 mf-mycorner-scroll'>
                    <Col md={8} className='mrgauto'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <img alt='' src={emptywatchlist} />
                            </Col>
                        </Row>

                        <Row className='g-0'>
                            <Col className='flex-column justify-content-center align-items-center'>
                                <Row className='g-0 pb-4'>
                                    <Col className='text-center'>
                                        <BzHeading className='font-medium font-size10 color-text'>Watchlist view is empty !</BzHeading>
                                    </Col>
                                </Row>

                                <Row className='g-0 pb-5'>
                                    <Col className='text-center'>
                                        <div className='font-regular font-size5 color-text'>Seems like you haven't created a watchlist yet.</div>
                                        <div className='font-regular font-size5 color-text'>Click below button to create one</div>
                                    </Col>
                                </Row>

                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-center'>
                                        <BzButton className='btn btn-md btn-primary d-flex align-items-center ms-2' onClick={handleOnCreateWatchlist}>
                                            <span>Create Watchlist</span>
                                            <div className='icon-14 icon-add-circle-fill icon-light icon-primary ms-2'></div>
                                        </BzButton>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>


            <CreateWatchlistModal
                newWatchlistName={newWatchlistName} setNewWatchlistName={setNewWatchlistName} globalWatchlists={newWatchlistsTemplate} globalWatchlistTemplateModalToggle={onSelect} onCreateNewCustomWatchlist={handleCustomWatchList}
            />

            <AddWatchListModal arrWatchlists={arrWatchlist} arrOpenWatchlists={fundList} onAddWatchlist={onAddWatchlist} onSelectFund={onSelectFund} />

            <CreateCustomWatchListModal newWatchlistName={newWatchlistName} setNewWatchlistName={setNewWatchlistName} mutualFund={mutualFund} currentWatchListName={currentWatchListName} mutualFundsScrips={mutualFundsScrips} setMutualFundsScrips={setMutualFundsScrips} />

        </>
    );
};

export default memo(EmptyWatchlistModal);